"use client";

import { IconProps } from "@/data/types";

export default function BbqIcon({
  width = 32,
  height = 32,
  color = "#000000",
  className,
}: IconProps) {
  return (
    <div className={className}>
      <svg
        version="1.1"
        id="Uploaded_to_svgrepo_com"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill={color}
        stroke={color}
        strokeWidth="0.00032"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path
            fill={color}
            d="M27.5,13H27c0-5.034-3.386-7.214-8.002-7.814c0.001,0,0.001,0,0.002,0V4c0-0.552-0.448-1-1-1h-4
               c-0.552,0-1,0.448-1,1v1.186c0.001,0,0.001,0,0.002,0C8.386,5.786,5,7.966,5,13H4.5C4.224,13,4,13.224,4,13.5v0
               C4,13.776,4.224,14,4.5,14H5c0,3.981,2.122,7.458,5.29,9.389l-2.552,5.955C7.629,29.597,7.746,29.891,8,30
               c0.254,0.109,0.547-0.009,0.656-0.263L9.401,28h13.198l0.745,1.737C23.452,29.991,23.746,30.109,24,30
               c0.254-0.109,0.371-0.403,0.263-0.656l-2.552-5.955C24.878,21.458,27,17.981,27,14h0.5c0.276,0,0.5-0.224,0.5-0.5v0
               C28,13.224,27.776,13,27.5,13z M14,5.08V4h4v1.08l0,0C17.351,5.028,16.684,5,16,5S14.649,5.028,14,5.08L14,5.08z 
               M22.17,27H9.83 l1.341-3.128C12.63,24.587,14.265,25,16,25s3.37-0.413,4.83-1.128L22.17,27z 
               M16,24c-5.514,0-10-4.486-10-10h20 
               C26,19.514,21.514,24,16,24z M6,13c0-7,7.527-7,10-7s10,0,10,7H6z"
          />
        </g>
      </svg>
    </div>
  );
}
